import Action from "../actions/ParcelamentoRateio";

const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case Action.SET:
			return { ...state, ...action.payload };
		case Action.CLEAR:
			return initialState;
		default:
			return state;
	}
};
